/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosResponse } from 'axios';
import { InfoNotification } from '../../../app.notification';
import { AxiosErrorResponse } from '../../../app.settings';

import api from '../../../axios';
import { ICoordenadoria } from './model';

export async function getById(usuarioId: string): Promise<ICoordenadoria | any> {
  try {
    const { data } = await api.get<AxiosResponse<ICoordenadoria>>('/coordenadoria/' + usuarioId);
    return data as unknown as ICoordenadoria;
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}
export async function getAll(): Promise<ICoordenadoria[] | undefined> {
  try {
    const { data } = await api.get<AxiosResponse<ICoordenadoria[]>>('/coordenadoria');
    return data as unknown as ICoordenadoria[];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function update(usuario: Partial<ICoordenadoria>): Promise<ICoordenadoria | any> {
  try {
    const { data } = await api.put<AxiosResponse<ICoordenadoria>>('/coordenadoria/' + usuario.id, {
      ...usuario,
    });
    return (data as unknown as ICoordenadoria[])[0];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function insert(usuario: ICoordenadoria): Promise<ICoordenadoria | any> {
  try {
    const { data } = await api.post<AxiosResponse<ICoordenadoria>>('/coordenadoria/', {
      ...usuario,
    });
    return (data as unknown as ICoordenadoria[])[0];
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function save(usuario: ICoordenadoria): Promise<ICoordenadoria | any> {
  try {
    if (usuario.id) {
      return await update(usuario).then(() => {
        InfoNotification('Registro alterado!');
      });
    } else {
      return await insert(usuario).then(() => {
        InfoNotification('Registro criado!');
      });
    }
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}

export async function remove(usuarioId: string): Promise<ICoordenadoria | any> {
  try {
    return await api
      .delete<AxiosResponse<ICoordenadoria>>('/coordenadoria/' + usuarioId)
      .then(() => {
        InfoNotification('Registro excluido!');
      });
  } catch (error: any) {
    AxiosErrorResponse(error);
  }
}
